import React from 'react';
import {usePrivateImage, privateMediaUrl} from '../../helpers/privateMedia';

export default function PrivateImage({src, alt = '', ...props}) {
    const image = usePrivateImage(src);
    return <img {...props} src={image.src || undefined} alt={image.error ? `${alt} – obrázok sa nepodarilo načítať` : alt}
        data-private-source={privateMediaUrl(src) ? src : undefined}
        data-private-loading={image.loading ? 'true' : undefined}
        data-private-error={image.error ? 'true' : undefined}/>;
}
